import Loading from "./Loading";

import styles from "../../styles/LoadingContainer.module.less";

const LoadingContainer = () => {
  return (
    <div className={styles.container}>
      <Loading />
    </div>
  );
};

export default LoadingContainer;
